module.exports = __webpack_public_path__ + "img/homejoin.8cf0a9e6.png";